/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ShippingAndBilling.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Avanthi G(E860178)
 *
 * @Date			    : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 30, 2019
 * Description   : Implemented External css for paymetric asds-957
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 *
 * By            : Deepthi Bachu
 * On            : Sep 25 2019
 * Description   : ASDS-1285
 *
 * By            	: Madhu Gali - H175591
 * On            	: Oct 10, 2019
 * Description   : ASDS-1476
 *
 * By            : Sandeep Raja
 * On            : Nov 20, 2019
 * Description   : Added rel="noopener noreferrer"
 *
 * By            : H422335
 * On            : Nov 26, 2020
 * Description   : Removed the target="_blank" on email to fix linting issue
 ******************************************************************************/
import * as React from 'react';
import { connect } from "react-redux";
import PaymetricActions from '../redux/actions/paymetric-actions';
import GenericLoader, { InLineLoader } from '../Loader/Loader';
import './paymetricStyles.css'
import { IFrame_OnLoad } from './ccActions.jsx';

interface IProps {
    paymetricCall: Function,
    paymetricData: any,
    isValidating: boolean,
}

class PaymetricScreen extends React.Component<IProps> {

    componentDidMount() {
        if (this.props.paymetricData.count < 1) {
            this.props.paymetricCall();
        }
    }

    render() {
        return (
            <>
                {!this.props.paymetricData.isFetching &&
                    this.props.paymetricData.payload &&
                    this.props.paymetricData.payload.embedIframeUrl
                    &&
                    <div>
                        <iframe title="creaditCard" id="IFrame"
                            src={this.props.paymetricData.payload.embedIframeUrl}
                            name="dieCommFrame" className='paymetricIframe'
                            onLoad={IFrame_OnLoad}
                        />
                        <a className="cvv" href="https://www.cvvnumber.com/cvv.html" target="_blank" rel="noopener noreferrer" >What is CVV?</a>
                        <p className="helpText">Your card will be charged once you review and confirm order.</p>
                        {this.props.isValidating &&
                            <div>
                                <GenericLoader text="Validating Credit Card details" className="cart-list-loader" loading={true} overlayColor='rgb(247, 247, 247)' />
                            </div>
                        }
                    </div>
                }
                {this.props.paymetricData.isError &&
                    <>
                        Unable to load Credit Card Section. Please reach out to <a href="mailto:dsa@honeywellaerospace.com">dsa@honeywellaerospace.com</a> for assistance.
                    </>
                }
                {this.props.paymetricData.isFetching
                    &&
                    <>
                        <InLineLoader loading={true} text="Loading Credit Card Section" overlayColor="transparent">
                        </InLineLoader>
                    </>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        paymetricData: state.paymetricData,
        isValidating: state.shippingBillingData.payload.validationsFlag.isValidating,
    }
}

const mapDispatchToProps = {
    paymetricCall: PaymetricActions.getPaymetricURL,
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymetricScreen);